import { format, formatDate, isValid, parse, parseISO } from "date-fns";

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Parses date strings as local calendar dates. Avoids `new Date("yyyy-MM-dd")`,
 * which is interpreted as UTC midnight and can shift the day in local timezones.
 */
export const parseLocalDateString = (value?: string | null): Date | null => {
  if (!value?.trim()) return null;

  const trimmed = value.trim();

  if (DATE_ONLY_PATTERN.test(trimmed)) {
    const parsed = parse(trimmed, "yyyy-MM-dd", new Date());
    return isValid(parsed) ? parsed : null;
  }

  const parsed = parseISO(trimmed);
  return isValid(parsed) ? parsed : null;
};

export const formatLocalISOString = (date: Date): string =>
  format(date, "yyyy-MM-dd'T'HH:mm:ssxxx");

export const GetLocalStartOfDayISOString = (dt: Date | null) => {
  if (!dt) return "";
  return format(
    new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0, 0),
    "yyyy-MM-dd'T'HH:mm:ssxxx",
  );
};

export const GetLocalEndOfDayISOString = (dt: Date | null) => {
  if (!dt) return "";
  return format(
    new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59, 59, 0),
    "yyyy-MM-dd'T'HH:mm:ssxxx",
  );
};

export const ceilToFiveMinutes = (date: Date): Date => {
  const slotMs = 5 * 60 * 1000;
  const rounded = Math.ceil(date.getTime() / slotMs) * slotMs;
  const result = new Date(rounded);
  result.setSeconds(0, 0);
  return result;
};

export const addMinutes = (date: Date, minutes: number): Date =>
  new Date(date.getTime() + minutes * 60 * 1000);

export const getTimeFromISOString = (isoString: string): string => {
  if (!isoString) return "";
  return formatDate(parseISO(isoString), "HH:mm");
};
